export default __webpack_public_path__ + "static/media/tocca-logo.5ee0fdf0.svg";